import axios from 'axios'

const urlBase = 'https://vqw9hp1iej.execute-api.us-east-1.amazonaws.com/desa/api';
//RG-536 `informes/opciones-filtro` vive en el gateway de informes, no en el de este módulo.
const urlBaseInformes = 'https://vyhzkzl1q7.execute-api.us-east-1.amazonaws.com/desa/api';

/**
 * @param {string}  url url a la cual consultar
 * esta funcion detecta si es una nueva url base (comienza con http:// o https://).
 * en caso de ser asi, retorna la url. en caso contrario, se asume que es un fragmento
 * de path por lo que se concatena con la constante urlBase
 **/
const readUrl = (url = '') =>
    url.startsWith('http://') || url.startsWith('https://') ? url : `${urlBase}/${url}`;

const readUrlInformes = (url = '') =>
    url.startsWith('http://') || url.startsWith('https://') ? url : `${urlBaseInformes}/${url}`;

/**
 * Instancia personalizada de axios para agregar interceptores 
 */
const instance = axios.create();

const get = (url = '', headers = {}) => instance.get(readUrl(url), {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers
    }
})

const post = (url = '', body = {}, headers = {}) => instance.post(readUrl(url), body, {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers
    }
})

const put = (url = '', body = {}, headers = {}) => instance.put(readUrl(url), body, {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers
    }
})

const del = (url = '', headers = {}) => instance.delete(readUrl(url), {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers
    }
})
const getInformes = (url = '', headers = {}) => instance.get(readUrlInformes(url), {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers
    }
})
const postLogin = (url = '', body = {}, headers = {}) => instance.post(readUrl(url), body, {
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        ...headers
    }
})
const client = {
    instance: instance,
    get: get,
    getInformes: getInformes,
    post: post,
    put: put,
    delete: del ,
    postLogin: postLogin
}

export default client;
